<template>
  <el-config-provider :locale="elementLocale">
    <router-view />
  </el-config-provider>
</template>

<script setup>
import { elementLocale } from '@/locales/element'

onMounted(() => {
  nextTick(() => {
    // 初始化主题样式
    // handleThemeStyle(useSettingsStore().theme)
  })
})
</script>
